import React, { useState, useEffect } from "react";
import Button from "./Button"; 

function SuccessPopup({ 
  show, 
  onClose, 
  title = "Success!", 
  message = "Your action was completed successfully.",
  buttonText = "Close"
}) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!show) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div
        style={{
          ...styles.popup,
          padding: isMobile ? "var(--space-lg)" : "var(--space-2xl)",
          maxWidth: isMobile ? "280px" : "450px", 
          width: isMobile ? "90%" : "90%"
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            ...styles.icon,
            width: isMobile ? "60px" : "80px",
            height: isMobile ? "60px" : "80px",
            fontSize: isMobile ? "var(--font-size-4xl)" : "var(--font-size-6xl)"
          }}
        >
          ✓
        </div>
        <h2 style={{ 
          ...styles.title,
          fontSize: isMobile ? "var(--font-size-lg)" : "var(--font-size-2xl)"
        }}>
          {title}
        </h2>
        <p style={{ 
          ...styles.message,
          fontSize: isMobile ? "var(--font-size-md)" : "var(--font-size-lg)"
        }}>
          {message}
        </p>
        <div style={{ width: isMobile ? "80%" : "100%", margin: "0 auto" }}>
          <Button label={buttonText} onClick={onClose} />
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "var(--z-modal)"
  },
  popup: {
    backgroundColor: "var(--card-bg)",
    borderRadius: "var(--radius-xl)",
    textAlign: "center",
    boxShadow: "var(--shadow-xl)"
  },
  icon: {
    borderRadius: "var(--radius-full)",
    color: "var(--accent)",
    backgroundColor: "var(--primary)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto var(--space-lg)",
    fontWeight: "var(--font-weight-bold)"
  },
  title: {
    color: "var(--text-main)",
    fontWeight: "var(--font-weight-bold)",
    marginBottom: "var(--space-md)",
    lineHeight: "1.3"
  },
  message: {
    color: "var(--text-muted)",
    fontWeight: "var(--font-weight-normal)",
    lineHeight: "1.5",
    marginBottom: "var(--space-xl)"
  }
};

export default SuccessPopup;